// extracted by mini-css-extract-plugin
export default {"inner":"DropdownItem_inner__awW5U"};